import React from 'react'
import { Form } from 'react-bootstrap'

export default function SurveyForm({ register, errors, survey }) {
	return (
		<React.Fragment>
			<Form.Group>
				<Form.Label>Nombre <span className="text-danger">*</span></Form.Label>
				<Form.Control {...register('name', { required:true })} />
				{ errors.name && <Form.Text className="text-warning">Este campo es requerido.</Form.Text> }
			</Form.Group>
			<Form.Group>
				<Form.Label>Estado <span className="text-danger">*</span></Form.Label>
				<Form.Control
					as="select"
					{...register('active', { required: true })}
				>
					<option value="">:: Seleccionar una opción ::</option>
					<option value="1">Activa</option>
					<option value="0">Inactiva</option>
				</Form.Control>
				{ errors.active && <Form.Text className="text-warning">Este campo es requerido.</Form.Text> }
			</Form.Group>
		</React.Fragment>
	)
}